import { mapState, mapMutations } from 'vuex'
import debounce from 'lodash.debounce'
import FiltersSearch from '@/components/filters-search/filters-search.vue'

export default {
  name: 'SearchRegionOrders',
  components: {
    FiltersSearch
  },
  computed: {
    ...mapState({
      regionOrdersFilters: state => state.regionOrders.regionOrdersFilters
    })
  },
  methods: {
    ...mapMutations({
      setRegionOrdersFilters: 'regionOrders/SET_REGION_ORDERS_FILTERS'
    }),
    onInput: debounce(function(event) {
      this.setRegionOrdersFilters({
        ...this.regionOrdersFilters,
        offset: 0,
        search: event
      })
    }, '300ms')
  }
}